<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('coursetypes.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs4>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>

            <v-flex xs4>
              <v-select
                v-model="search_params.status"
                :items="[{ key: 'all', text: $t('global.dd_enrolment_list_status_all') }, ...$dd_course_types_status()]"
                item-text="text"
                item-value="key"
                :label="$t('coursetypes.status')"
                @change="filter"
                hide-details
              >
              </v-select>
            </v-flex>

            <v-flex xs4>
              <v-autocomplete
                name="coursetype.coursetypegroup_id"
                v-model="search_params.coursetypegroup_id"
                :items="coursetypegroups"
                item-text="name"
                item-value="id"
                :label="$t('coursetypegroups.title')"
                autocomplete="new-password"
                @change="filter"
                clearable
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/coursetypes/create'" v-if="$can('coursetype-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="coursetypes"
            :items-per-page="coursetypes.length"
            :options.sync="pagination"
            :footer-props="{
               showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.coursetypegroup_id="{ item }">
              {{ item.coursetypegroup.fullname }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_course_type_groups_status(item.status) }}
            </template>

            <template v-slot:item.register_interest="{ item }">
              {{ item.register_interest ? $t("global.yes") : $t("global.no") }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{ path: BACKEND_URL + '/coursetypes/edit/' + item.id, props: { id: item.id } }"
                v-if="$can('coursetype-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button type="delete" :icon_only="true" @click="del(item.id)" v-if="$can('coursetype-delete')" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesList",

  data() {
    return {
      url: "",
      coursetypes: [],
      coursetypegroups: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__courseTypeListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["category"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        name: "",
        status: 1
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("coursetypes.id"), value: "id" },
          { text: this.$t("coursetypes.name"), value: "name" },
          { text: this.$t("coursetypes.category"), value: "category" },
          { text: this.$t("coursetypegroups.title"), value: "coursetypegroup_id" },
          { text: this.$t("coursetypes.register_interest_short"), value: "register_interest" },
          { text: this.$t("coursetypes.status"), value: "status" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__coursetypeListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__coursetypeListSort", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__courseTypeListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "coursetypes"
    if (localStorage.getItem("__coursetypeListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__coursetypeListSearchParams"))
    }
  },

  created() {
    axios.get(this.API_URL + "coursetypegroups?show_all=true").then((res) => {
      this.coursetypegroups = res.data.data
    })
  },

  methods: {
    list() {
      this.show_loading = true

      let localSort = localStorage.getItem("__coursetypeListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.coursetypes = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetype/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
